import {reduxForm} from 'redux-form';
import * as fields from './fields';
import * as validators from './validators';
import * as normalizers from './normalizers';

const reduxFormWrapper = (class_, formName, ...args) => reduxForm({
    form: formName,
    enableReinitialize: true,
    ...args,
})(class_);

export {
    fields,
    validators,
    normalizers,
    reduxFormWrapper,
};



// WEBPACK FOOTER //
// ./src/js/utilities/form/index.js